module.exports = __webpack_public_path__ + "media/images/hospitals-hero-image-d4a360435d35ea25c1caf0beb45d5388.png";